import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Badge, Row, Col, Card } from 'antd';

class UrbioticaMessagesTable extends Component {

  state = {
    filteredInfo: null,
    children: []
  }
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters
    });
  };

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={20}>
            <Card title="messageObject" style={{ width: "100%" }}>
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {JSON.stringify(record.messageObject, null, 2)}
              </pre>
            </Card>
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let serials = [];
    this.props.data.forEach(element => {
      if ((element.serialNumber) && serials.indexOf(element.serialNumber) === -1) {
        serials.push(element.serialNumber);
      }
    });
    serials.sort();
    let serialFilter = [];
    serials.forEach(serialNumber => {
      serialFilter.push({ text: serialNumber, value: serialNumber });
    });
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={[
          {
            title: 'Sériové číslo',
            dataIndex: 'serialNumber',
            key: 'serialNumber',
            width: 30,
            filters: serialFilter,
            filteredValue: filteredInfo.serialNumber || null,
            onFilter: (value, record) => record.serialNumber === value,
            ellipsis: true
          }, {
            title: 'Occ',
            dataIndex: 'messageObject.telemetry.parking_status',
            key: 'messageObject.telemetry.parking_status',
            width: 150,
            render: (text, record) => {
              const parkingStatus = record.messageObject.telemetry && record.messageObject.telemetry.parking_status;
              if (parkingStatus === 'BUSY') {
                return (
                  <Badge
                    status="error"
                    text={"OBSAZENO"}
                    title="Obsazeno" />
                );
              } else if (parkingStatus === 'FREE') {
                return (
                  <Badge
                    status="success"
                    text={"VOLNO"}
                    title="Volno" />
                );
              } else if (parkingStatus === 'UNKNOWN' || parkingStatus === 'NOT_CALIBRATED') {
                return (
                  <Badge
                    color="#6d6d6d"
                    text={"NEZNÁMÝ STAV"}
                    title="Neznámý stav" />
                )
              } else if (record.productType) {
                return (
                  <Badge
                    color="#6d6d6d"
                    text={"Kalibrace / neznámý stav / chyba"}
                    title="Kalibrace / neznámý stav / chyba" />
                )
              } else {
                return '--'
              }
            }
          }, {
            title: 'Časová značka',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
            render: (text, record) => {
              return moment(text).format('L LTS');
            }
          }
        ]}
        dataSource={this.props.data}
        onChange={this.handleChange}
        expandedRowRender={this.expandedRowRender.bind(this)}
        style={{ border: '0px' }}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
      />
    );
  }
}

export default UrbioticaMessagesTable;


// WEBPACK FOOTER //
// ./src/components/FleximodoMessagesTable.js